import { useTranslation } from 'next-i18next';
import { useState } from 'react';

import { MountingGuideDialog } from './MountingGuideDialog';

export const MountingGuide = () => {
  const { t } = useTranslation('checkout');
  const [open, setOpen] = useState(false);

  return (
    <>
      <button className="hyperlink" onClick={() => setOpen(true)} type="button">
        {t('framing.seeGuide')}
      </button>
      <MountingGuideDialog open={open} onClose={() => setOpen(false)} />
    </>
  );
};
